// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toFixedDecimalPoint(value, decimalPoint) {
  return Caml_format.caml_float_of_string(value.toFixed(decimalPoint));
}

function DryRunRatioCmp(Props) {
  var filter_data = Props.filter_data;
  switch (filter_data.TAG | 0) {
    case /* DryRun */1 :
        var delta_value = filter_data.delta_value;
        var filter_value = filter_data.filter_value;
        return React.createElement("div", {
                    className: "allocation-filter-wrapper"
                  }, React.createElement("div", {
                        className: "left-element-container"
                      }, React.createElement("p", {
                            className: "left-element"
                          }, String(filter_value.left_value) + " KMS"), React.createElement("div", {
                            className: "delta-values"
                          }, delta_value !== undefined && delta_value.left_value !== 0.0 ? React.createElement("p", {
                                  className: "left-delta-element " + (
                                    delta_value.left_value > 0.0 ? "delta-positive" : "delta-negative"
                                  )
                                }, String(Caml_format.caml_float_of_string(delta_value.left_value.toFixed(2)))) : null)), React.createElement("div", {
                        className: "verticle-line"
                      }, null), React.createElement("div", {
                        className: "right-element-container"
                      }, React.createElement("p", {
                            className: "right-element"
                          }, String(filter_value.right_value)), React.createElement("div", {
                            className: "delta-values"
                          }, delta_value !== undefined && delta_value.right_value !== 0.0 ? React.createElement("p", {
                                  className: "right-delta-element " + (
                                    delta_value.right_value > 0.0 ? "delta-positive" : "delta-negative"
                                  )
                                }, String(Caml_format.caml_float_of_string(delta_value.right_value.toFixed(2)))) : null)));
    case /* AllocationRadius */0 :
    case /* MaxDryRun */2 :
        return ErrorUtils$Catalyst.raiseError("DryRunRatioCmp.res", "Invalid Filter Type", "");
    
  }
}

var make = DryRunRatioCmp;

export {
  toFixedDecimalPoint ,
  make ,
  
}
/* react Not a pure module */
